import log from 'salvo-lite/log'
import lax from 'lax.js'

class Wow {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)
        window.onload = function () {
            lax.setup() // init

            const updateLax = () => {
                lax.update(window.scrollY)
                window.requestAnimationFrame(updateLax)
            }

            window.requestAnimationFrame(updateLax)
        }
    }
}

export default Wow



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Wow.js